import { render, staticRenderFns } from "./knowledge-base.vue?vue&type=template&id=4a1f6d23&scoped=true"
import script from "./knowledge-base.vue?vue&type=script&lang=js"
export * from "./knowledge-base.vue?vue&type=script&lang=js"
import style0 from "./knowledge-base.vue?vue&type=style&index=0&id=4a1f6d23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f6d23",
  null
  
)

export default component.exports